import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, InputAdornment, Slide, TextField, Typography } from "@mui/material";
// yup
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { AlertMsg, AlertMsgTh, AlertTitle, AlertTitleTh, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { useLocation, useNavigate } from 'react-router-dom';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { AccountCircle, LockRounded } from "@mui/icons-material";
import  secureLocalStorage  from  "react-secure-storage";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas, { RegexpPassword } from 'components/Common/FormItem/yup/yupFormSchemas';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { TransitionProps } from '@mui/material/transitions';
import { BtnConfirm } from 'components/Common/Button';
import { i18n } from 'i18n';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
const i18nFieldCommon = "common";

const i18nFieldRegister = 'entities.DialogRegister.fields';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ModalChangePassword = (props) => {

    const {
        IsOpen,
        setIsOpen,
        sMaxWidth = "xs",
        sUserID,
        setIsOpenSnackbar,
        setsMessageSnackbar,
        setsSeveritySnackbar,
    } = props;

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const navigate = useNavigate();
    const [IsTypePass, setIsTypePass] = useState(true)
    const [IsTypeConfirmPass, setIsTypeConfirmPass] = useState(true)

    let objSchema = {
        sPassword: yupFormSchemas.string(i18n(`${i18nFieldCommon}.NewPassword`), { required: true, max: 25, matches: /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(){}[\]])(?=.{13,}))/, labelmatches: i18n(`${i18nFieldRegister}.sMatchPassword`) }),
        sConfirmPassword: yupFormSchemas.confirmPassword(i18n(`${i18nFieldCommon}.ConfirmPassword`), { required: true, max: 25, matchefield: "sPassword", }),
    }

    const schema = yup.object().shape(objSchema);

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        if (IsOpen == true) {
            form.setValue("sPassword", null)
            form.setValue("sConfirmPassword", null)
        }
    }, [IsOpen])

    const onSubmitReject = () => {
        let param = {
            "sUserID": sUserID,
            "sPassword": form.getValues("sPassword") ?? null
        }
        let sMessage = currentLanguage() == "th" ? "คุณต้องการที่จะเปลี่ยนรหัสผ่านใช่หรือไม่ ?" : "Do you want to change your password ?"
        SwAlert.Confirm(AlertTitle.Confirm, sMessage, () => {
            setIsOpen(false)
            BlockUI();

            AxiosPost(`User/ChangePassword`, param, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    setIsOpen(false)
                    setIsOpenSnackbar(true);
                    setsMessageSnackbar("บันทึกข้อมูลสำเร็จ")
                    setsSeveritySnackbar("success")

                    setTimeout(() => {
                        SwAlert.Confirm(AlertTitle.Confirm, AlertMsg.confirmLogout, () => {
                            secureLocalStorage.clear();
                            secureLocalStorage.setItem('languageUvoice', "th");
                            navigate("/Home")
                            window.location.reload();
                        });
                    }, 1000)

                })
            }, null, null)
        })
    }

    return (
        <Dialog
            open={IsOpen}
            TransitionComponent={Transition}
            onClose={() => { setIsOpen(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth={sMaxWidth}
        >
            <DialogTitle>{i18n(`${i18nFieldCommon}.ChangePassword`)}</DialogTitle>
            <hr style={{ width: '100%', margin: '0' }} />
            <DialogContent style={{ paddingBottom: '0' }}>
                <FormProvider {...form}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={10}>
                            <InputFormItem
                                id="sPassword"
                                name="sPassword"
                                // type="password"
                                type={!IsTypePass ? "text" : "password"}
                                label={i18n(`${i18nFieldCommon}.NewPassword`)}
                                required={true}
                                fullWidth
                                endAdornment={
                                    <>
                                        <IconButton
                                            style={{ padding: '0px' }}
                                            onClick={(() => { setIsTypePass(!IsTypePass) })}
                                        >
                                            {IsTypePass ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                                        </IconButton>
                                    </>
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={10}>
                            <InputFormItem
                                id="sConfirmPassword"
                                name="sConfirmPassword"
                                // type="password"
                                type={!IsTypeConfirmPass ? "text" : "password"}
                                label={i18n(`${i18nFieldCommon}.ConfirmPassword`)}
                                required={true}
                                fullWidth
                                endAdornment={
                                    <>
                                        <IconButton
                                            style={{ padding: '0px' }}
                                            onClick={(() => { setIsTypeConfirmPass(!IsTypeConfirmPass) })}
                                        >
                                            {IsTypeConfirmPass ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                                        </IconButton>
                                    </>
                                }
                            />
                        </Grid>
                    </Grid>
                </FormProvider>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                    <Grid item>
                        <BtnConfirm txt={i18n(`${i18nFieldCommon}.btnConfirm`)} onClick={form.handleSubmit(() => { onSubmitReject() })} />
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

export default ModalChangePassword